import { render, staticRenderFns } from "./IcoPlusCircle.vue?vue&type=template&id=4dd51125"
import script from "./IcoPlusCircle.vue?vue&type=script&lang=js"
export * from "./IcoPlusCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports